import { createApp } from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue';
import "./assets/base.less";
import "./assets/css/global.css";
import router from './router'
import resize from "@/directives/resize";
import emitter from './utils/event-bus';

import "./utils/rem"
const app = createApp(App)
app.use(router)
app.use(Antd)
app.provide('$emitter', emitter); // 提供给 inject
app.config.globalProperties.$emitter = emitter;
app.directive("chart-resize", { mounted: resize.bind, unmounted: resize.unbind });
app.mount('#app')